import {
  BaseEntityDTO,
  BranchYearDTO,
  IBaseEntityDTO,
  IBranchYearDTO,
  ITeamDTO,
  ITeamRoleDTO,
  IUserDTO,
  TeamDTO,
  TeamRoleDTO,
  UserDTO,
} from './';

export interface IParticipantDTO extends IBaseEntityDTO {
  branchYear?: IBranchYearDTO;
  team?: ITeamDTO;
  code: string;
  teamRole?: ITeamRoleDTO;
  user?: IUserDTO;
}

export class ParticipantDTO extends BaseEntityDTO implements IParticipantDTO {
  branchYear?: IBranchYearDTO;
  team?: ITeamDTO;
  code: string;
  teamRole?: ITeamRoleDTO;
  user?: IUserDTO;

  constructor(data?: Partial<ParticipantDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.branchYear = data?.branchYear ? new BranchYearDTO(data.branchYear) : undefined;
    this.team = data?.team ? new TeamDTO(data.team) : undefined;
    this.code = data?.code ?? '';
    this.teamRole = data?.teamRole ? new TeamRoleDTO(data.teamRole) : undefined;
    this.user = data?.user ? new UserDTO(data.user) : undefined;
  }
}
